<template>
    <div class="currency-ticker">
        <span class="ticker-label">USD/EUR:</span>
        <span class="ticker-value">{{ rateText || 'Cargando...' }}</span>
        <span v-if="trendSymbol" :class="['ticker-trend', trendClass]">{{ trendSymbol }}</span>
    </div>
</template>

<script>
export default {
    name: 'CurrencyTicker',
    data() {
        return {
            rateText: null,
            trendSymbol: '',
            trendClass: '',
            currentRate: null,
            previousRate: null
        }
    },
    mounted() {
        this.fetchCurrency()
        // Actualizar cada 60 segundos (como en el script original)
        this.interval = setInterval(this.fetchCurrency, 60000)
    },
    beforeUnmount() {
        if (this.interval) clearInterval(this.interval)
    },
    methods: {
        async fetchCurrency() {
            try {
                const controller = new AbortController()
                const timeoutId = setTimeout(() => controller.abort(), 3000)

                const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD', {
                    signal: controller.signal
                })
                clearTimeout(timeoutId)

                if (!response.ok) throw new Error('Network response was not ok')

                const data = await response.json()
                const rate = data.rates.EUR
                
                // Guardar rate anterior para calcular tendencia
                this.previousRate = this.currentRate
                this.currentRate = rate
                
                // Formatear el texto
                this.rateText = `1 USD = ${rate.toFixed(4)} EUR`
                
                // Calcular tendencia
                this.calculateTrend()

            } catch (error) {
                console.warn('Currency fetch failed, using fallback:', error)
                const fallbackRate = 0.9250
                this.previousRate = this.currentRate
                this.currentRate = fallbackRate
                this.rateText = `1 USD ≈ ${fallbackRate.toFixed(4)} EUR`
                this.trendSymbol = ''
                this.trendClass = ''
            }
        },
        calculateTrend() {
            if (this.previousRate !== null && this.currentRate !== null) {
                if (this.currentRate > this.previousRate) {
                    this.trendSymbol = '▲'
                    this.trendClass = 'trend-up'
                } else if (this.currentRate < this.previousRate) {
                    this.trendSymbol = '▼'
                    this.trendClass = 'trend-down'
                } else {
                    this.trendSymbol = '●'
                    this.trendClass = 'trend-neutral'
                }
            } else {
                // Primera carga, mostrar tendencia aleatoria como en el original
                const isUp = Math.random() > 0.5
                this.trendSymbol = isUp ? '▲' : '▼'
                this.trendClass = isUp ? 'trend-up' : 'trend-down'
            }
        }
    }
}
</script>

<style scoped>
/* Estos estilos ya están en tu CSS global, pero los pongo por si acaso */
.currency-ticker {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
    font-size: 0.85rem;
    background: #e9ecef;
    padding: 4px 10px;
    border-radius: 4px;
    color: #495057;
}

.ticker-label {
    font-weight: 600;
    margin-right: 5px;
}

.ticker-value {
    font-weight: 700;
    color: #1C4A8D;
}

.ticker-trend {
    margin-left: 5px;
    font-size: 0.8em;
}

.trend-up {
    color: #28a745;
}

.trend-down {
    color: #dc3545;
}

.trend-neutral {
    color: #ffc107;
}
</style>